import { SideBarOptions } from '../../interfaces';
import { UiState } from './';

export enum templateContextTypes {
    ACTION_TYPE_TOGGLE_SIDEBAR = 'Ui - toggle Sidebar',
    ACTION_CLOSE_SIDEBAR = 'Ui - close Sidebar',
}

type UiActionType = 
| { type: templateContextTypes.ACTION_TYPE_TOGGLE_SIDEBAR, payload: {isOpenSideBar: boolean, optionSidebarOpen: SideBarOptions} }
| { type: templateContextTypes.ACTION_CLOSE_SIDEBAR }

export const uiReducer = ( state: UiState, action: UiActionType ): UiState => {
    switch (action.type) {
        case templateContextTypes.ACTION_TYPE_TOGGLE_SIDEBAR:
            return{
                ...state,
                isOpenSideBar: action.payload.isOpenSideBar,
                optionSidebarOpen: action.payload.optionSidebarOpen
            }
        case templateContextTypes.ACTION_CLOSE_SIDEBAR:
            return{
                ...state,
                isOpenSideBar: false,
            }
        default:
            return state;
    }
}